import { Component, OnInit } from '@angular/core';
import { ProductosService } from 'src/app/services/productos.service';
import { Subject } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { environment } from '../../../environments/environment';
import { DataTableDirective } from 'angular-datatables';


@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent implements OnInit {

  environment = environment.BASE_URL
  productos;
  formulario;
  data;
  respuestaProductos: any;
  respuestaAgregarProducto: any;
  respuestaEditarProducto: any;
  respuestaUpdateProducto: any;

  productoid;
  datosProducto;
  formularioEdit;
  imagenActual;

  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();

  constructor(private _getProductos: ProductosService, private modalService: NgbModal, private _agregarProducto: ProductosService,
    private iziToast: Ng2IzitoastService, private _editarProducto: ProductosService, private _updateProducto: ProductosService) { }

  ngOnInit(): void {
    this.getProductos();
    this.formulario = {
      'nombre':'',
    }

    this.formularioEdit = {
      'nombre':'',
    }

    this.dtOptions = {
      pagingType: 'full_numbers',
      ordering: false,
      pageLength: 20,
      processing: true
    };
  }

  getProductos(){
    this._getProductos.getProductos().subscribe(
      data => {
        this.respuestaProductos = data;
        if(this.respuestaProductos.success){
          this.productos = this.respuestaProductos.content;
          this.dtTrigger.next();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  imageChange(files: FileList){
    this.formulario.imagen = files.item(0);
    // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formulario.imagen.type.toString() == 'image/png' ||
        this.formulario.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formulario.imagen.size > 10485760) {
          this.formulario.imagen = null;
          $('#imagen').focus();
          return;
        }
        console.log('File Change', this.formulario.imagen);
    } else {
      this.formulario.imagen = null;
      $('#imagen').focus();
      return;
    }
  }

  agregarProducto(){
    // this.data = {
    //   'nombre': this.formulario.nombre,
    // }
    const formData = new FormData();
    formData.append('nombre', this.formulario.nombre);
    formData.append('precio', this.formulario.precio);
    if (this.formulario.imagen){ 
      formData.append('imagen', this.formulario.imagen);
    }

    this._agregarProducto.agregarProducto(formData).subscribe(
      data => {
        this.respuestaAgregarProducto = data;
        if(this.respuestaAgregarProducto.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado el pago correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.dtTrigger.unsubscribe();
          this.dismissAll();
          this.getProductos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }


  editarProducto(producto){
    this.data = {
      'producto':producto,
    }
    this._editarProducto.editarProducto(this.data).subscribe(
      data => {
        this.respuestaEditarProducto = data;
        if(this.respuestaEditarProducto.success){
          this.datosProducto = this.respuestaEditarProducto.content;
          this.formularioEdit.nombre = this.datosProducto.nombre;
          this.formularioEdit.precio = this.datosProducto.precio;
          this.imagenActual = this.datosProducto.imagen;
          this.productoid = producto;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  imageChangeEdit(files: FileList){
    this.formularioEdit.imagen = files.item(0);
  // || this.invoice.ticket.type.toString() !== 'image/jpeg'
    if (this.formularioEdit.imagen.type.toString() == 'image/png' ||
        this.formularioEdit.imagen.type.toString() == 'image/jpeg' ) {
        if (this.formularioEdit.imagen.size > 10485760) {
          this.formularioEdit.imagen = null;
          $('#imagen2').focus();
          return;
        }
        console.log('File Change', this.formularioEdit.imagen);
    } else {
      this.formularioEdit.imagen = null;
      $('#imagen2').focus();
      return;
    }
  }

  updateProducto(producto){
    const formData = new FormData();
    formData.append('nombre', this.formularioEdit.nombre);
    formData.append('precio', this.formularioEdit.precio);
    formData.append('producto', producto);
    if (this.formularioEdit.imagen){ 
      formData.append('imagen', this.formularioEdit.imagen);
    }


    this._updateProducto.updateProducto(formData).subscribe(
      data => {
        this.respuestaUpdateProducto = data;
        if(this.respuestaUpdateProducto.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado el cliente correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.dtTrigger.unsubscribe();
          this.getProductos();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
